import { commonRequest } from '@/utils/request'
/** 获取单元行为统计 */
export function getOrgDevVersion(params: {
  orgId: string
}) {
  return commonRequest({
    method: 'get',
    url: '/V1/Admin/Dev/OrgDevVersion',
    params,
  })
}

export function orgExcel(params: {
  orgId: string
}) {
  return commonRequest({
    method: 'get',
    url: '/V1/Org/orgExcel',
    params,
  })
}
